"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 5.2A2.2 2.2 0 0 1 5.2 3h1.2a2.2 2.2 0 0 1 2.2 2.2v1.2a2.2 2.2 0 0 1-2.2 2.2H5.2A2.2 2.2 0 0 1 3 6.4zm2.2-.8a.8.8 0 0 0-.8.8v1.2a.8.8 0 0 0 .8.8h1.2a.8.8 0 0 0 .8-.8V5.2a.8.8 0 0 0-.8-.8zm6.2 9.2a2.2 2.2 0 0 1 2.2-2.2h1.2a2.2 2.2 0 0 1 2.2 2.2v1.2a2.2 2.2 0 0 1-2.2 2.2h-1.2a2.2 2.2 0 0 1-2.2-2.2zm2.2-.8a.8.8 0 0 0-.8.8v1.2a.8.8 0 0 0 .8.8h1.2a.8.8 0 0 0 .8-.8v-1.2a.8.8 0 0 0-.8-.8z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.535 6.227h-.144v-1.4h.144a.7.7 0 1 1 0 1.4m1.62-.7a.7.7 0 0 1 .7-.7h.282a.7.7 0 1 1 0 1.4h-.282a.7.7 0 0 1-.7-.7m2.481 0a.7.7 0 0 1 .7-.7h.137q.12 0 .235.01a.7.7 0 0 1-.12 1.395 1 1 0 0 0-.115-.005h-.137a.7.7 0 0 1-.7-.7m2.77 1.128a.7.7 0 0 1 .757.637q.01.116.01.235v.137a.7.7 0 1 1-1.4 0v-.137q0-.058-.005-.115a.7.7 0 0 1 .638-.757m-9.58.88v-.144h1.4v.145a.7.7 0 1 1-1.4 0m.7 1.62a.7.7 0 0 1 .7.7v.282a.7.7 0 1 1-1.4 0v-.282a.7.7 0 0 1 .7-.7m8.947.008a.7.7 0 0 1 .7.7v.282a.7.7 0 1 1-1.4 0v-.282a.7.7 0 0 1 .7-.7m-8.946 2.473a.7.7 0 0 1 .7.7v.137q0 .059.005.115a.7.7 0 1 1-1.395.12 3 3 0 0 1-.01-.235v-.137a.7.7 0 0 1 .7-.7m8.946.129a.7.7 0 0 1 .7.7v.145h-1.4v-.145a.7.7 0 0 1 .7-.7m-7.818 2.64a.7.7 0 0 1 .757-.636q.057.004.115.004h.137a.7.7 0 1 1 0 1.4h-.137q-.12 0-.235-.01a.7.7 0 0 1-.637-.757m2.508.068a.7.7 0 0 1 .7-.7h.282a.7.7 0 1 1 0 1.4h-.282a.7.7 0 0 1-.7-.7m2.601 0a.7.7 0 0 1 .7-.7h.146v1.4h-.146a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ProofBoxDashedIcon20.js.map